import { useRef, useEffect } from 'react';
import type { TranscriptEntry } from '../types';
import { DIRECTION_LABELS , TARGET_LABELS } from '../types';
import { t } from '../i18n';

interface Props {
  transcript: TranscriptEntry[];
  onExport: (format: 'txt' | 'csv' | 'json') => void;
  unsaved?: boolean;
  onClear: () => void;
}

export default function TranscriptHistory({ transcript, onExport, onClear, unsaved = false }: Props) {
  const listRef = useRef<HTMLUListElement>(null);

  // 新しいエントリが追加されたら自動スクロール
  useEffect(() => {
    if (listRef.current) {
      listRef.current.scrollTop = listRef.current.scrollHeight;
    }
  }, [transcript.length]);

  return (
    <div className="card" style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
      <div className="card-title" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span>{t(`翻訳履歴 (${transcript.length}件)`, `History (${transcript.length})`)}
          {unsaved && transcript.length > 0 && (
            <span style={{ marginLeft: '0.5rem', fontSize: '0.75rem', color: '#b45309', fontWeight: 600 }}>{t('未保存', 'Not saved')}</span>
          )}
        </span>
        <div className="btn-group">
          {transcript.length > 0 && (
            <>
              <button className="btn btn-ghost btn-sm" onClick={() => onExport('txt')}>TXT</button>
              <button className="btn btn-ghost btn-sm" onClick={() => onExport('csv')}>CSV</button>
              <button className="btn btn-ghost btn-sm" onClick={() => onExport('json')}>JSON</button>
              <button
                className="btn btn-ghost btn-sm"
                onClick={onClear}
                title={t('履歴をクリア', 'Clear history')}
              >
                🗑
              </button>
            </>
          )}
        </div>
      </div>

      {transcript.length === 0 ? (
        <p style={{ fontSize: '0.8rem', color: '#9ca3af', textAlign: 'center', padding: '1rem 0' }}>
          {t('翻訳が開始されると、ここに履歴が表示されます', 'Translated captions will appear here')}
        </p>
      ) : (
        <ul className="history-list" ref={listRef}>
          {transcript.slice().reverse().map((entry) => (
            <li key={entry.id} className="history-item">
              <div className="history-meta">
                <span>{new Date(entry.timestamp).toLocaleTimeString('ja-JP')}</span>
                <span>{entry.target ? `→ ${TARGET_LABELS[entry.target] ?? entry.target}` : DIRECTION_LABELS[entry.direction].label}</span>
              </div>
              {entry.original && (
                <div className="history-original">{entry.original}</div>
              )}
              <div className="history-translation">{entry.translation}</div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
